var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CardApiClient } from './cardApiClient';
import { filtersToParams, getDateRangeFiltersFormatted } from '../utils/filtersUtils';
import { serializeParams } from '../utils/queryStringUtils';
function buildTaxesParams(_a) {
    var filters = _a.filters, dateRange = _a.dateRange, currency = _a.currency;
    var params = __assign(__assign({}, filtersToParams(filters)), { currency: currency });
    params['daterange'] = getDateRangeFiltersFormatted(dateRange);
    return serializeParams(params);
}
export function getTaxes(options) {
    return CardApiClient.get("v1/taxes.json?" + buildTaxesParams(options)).then(function (response) { return response.data; });
}
export function createTaxesReport(params) {
    return CardApiClient.get("v1/taxes.xls?" + buildTaxesParams(params)).then(function (response) { return response.data; });
}
